import { Component, OnInit, inject } from '@angular/core';
import { DataAccessService } from '../core/services/data-access.service';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';


export interface Attachments {
  filename: string;
  section: string;
  description: string;
  icon: string;
  v_supplier: boolean;
  v_customer: boolean;
  v_bdm: boolean;
  v_bd: boolean;
  v_sp: boolean;
  v_pne: boolean;
  v_su: boolean;
  v_bn: boolean;
  v_pnesu: boolean;
  v_viewer: boolean;
}

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html',
    styleUrls: ['./help.component.scss'],
    imports: [MatButton, MatIcon]
})
export class HelpComponent implements OnInit {
  private dataAccess = inject(DataAccessService);

  files: Attachments[] = [];
  templates: Attachments[] = [];
  manuals: Attachments[] = [];

  ngOnInit() {
    this.dataAccess.getJSON("get_files_for_download", [], []).then(data => {
      this.files = (Array.isArray(data) ? data : []);

      this.templates = this.files.filter(x => x.section == 'templates');
      this.manuals = this.files.filter(x => x.section == 'manual');
    });
  }
}
